import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  noUsageDimensionContainer: {
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
  },
  field: {
    width: '485px',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    alignSelf: 'stretch',
  },
  checkboxWidth: {
    width: '244px',
  },
  row: {
    display: 'flex',
    padding: theme.spacing(4),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    alignSelf: 'stretch',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.dividerV2.main}`,
  },
  usageRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1.1),
    alignSelf: 'stretch',
  },
  icon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    objectFit: 'contain',
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  titleAndIcon: {
    width: '100%',
    display: 'flex',
    position: 'relative',
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
  },
  checkboxTitle: {
    color: theme.palette.labraText.tertiary,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
  },
  checkboxSubtitle: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    paddingTop: theme.spacing(1),
  },
  buttonSubText: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    marginTop: '-32px',
  },
  headingWithDesc: {
    paddingBottom: theme.spacing(1),
  },
  headingDescription: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    display: 'contents',
  },
  descriptionBottom: {
    paddingBottom: theme.spacing(3),
  },
  linkWrapper: {
    display: 'contents',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.select.light,
    paddingLeft: theme.spacing(0.25),
  },
  displayName: {
    paddingTop: `${theme.spacing(1)} !important`,
  },
  highLightedText: {
    fontWeight: 500,
    color: theme.palette.select.light,
  },
  sectionBottom: {
    paddingBottom: theme.spacing(3),
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  disableTrash: {
    pointerEvents: 'none',
  },
}))
